.badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  height: 1.75rem;
  padding: 0 var(--space-3);
  border-radius: var(--radius-full);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  white-space: nowrap;
}

.dot {
  width: 0.4375rem;
  height: 0.4375rem;
  border-radius: var(--radius-full);
  background-color: currentcolor;
}

.neutral {
  background-color: var(--color-surface-2);
  color: var(--color-text-2);
}

.accent {
  background-color: var(--color-accent-soft);
  color: var(--color-accent-text);
}

.success {
  background-color: var(--color-success-soft);
  color: var(--color-success);
}

.warning {
  background-color: var(--color-warning-soft);
  color: var(--color-warning);
}

.danger {
  background-color: var(--color-danger-soft);
  color: var(--color-danger);
}

.info {
  background-color: var(--color-info-soft);
  color: var(--color-info);
}
